import SimClientSideFilter
    from "../../../../../../../../../../shared/components/sim-client-side-table-and-filter/sim-client-side-filter/SimClientSideFilter";
import FilterHistory from "../../../../../../../../../../shared/components/filter-history/FilterHistory";
import {filterInitialState, headCells, sortingCriteria} from "./AssociatedSimsToPlanHelper";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {updateObject} from "../../../../../../../../../../shared/utils/updateObject";
import {shouldDisableDispositiveActions} from "../../../../../../../sim/SimHelper";
import {E2_01_D_03_9} from "../../../../../../../../../../shared/texts";
import ClickableDropdown from "../../../../../../../../../ui/dropdowns/clickable-dropdown/ClickableDropdown";
import Grid from "@material-ui/core/Grid";
import SortingDropdown from "../../../../../../../../../../shared/components/sorting-dropdown/SortingDropdown";
import {Button} from "@material-ui/core";
import ChangePlanBySimDialog
    from "../../../../../../../../../../shared/components/dialogs/change-plan-by-sim-dialog/ChangePlanBySimDialog";
import PianoDialog from "../../../../../../../sim/Dialogs/piano-dialog/PianoDialog";
import {simsToIccIdAndMsisdnList} from "../../../../../../../../../../shared/utils/utils";
import ChangeOptionDialog from "./change-option-dialog/ChangeOptionDialog";
import AggiuntaSimOptionDialog from "./aggiunta-sim-option-dialog/AggiuntaSimOptionDialog";
import {useParams} from "react-router-dom";
import * as actions from "../../../../../../../../../../store";
import {getServiceType} from "../../../OfferteHelper";
import SimServerSideTable
    from "../../../../../../../../../../shared/components/sim-server-side-table/SimServerSideTable";

const AssociatedSimsToPlan = (props) => {
    const [openChangePiano, setOpenChangePiano] = useState(false)
    const [openChangeOptionDialog, setOpenChangeOptionDialog] = useState(false)
    const [openAggiuntaSimDialog, setOpenAggiuntaSimDialog] = useState(false)

    const associatedSimsToPlan = useSelector((state) => state.contrattoDigitaleReducer.simsAssociatedToPlan)
    const typeUser = useSelector(state => state.authReducer.userClaims.typeUser)
    const roles = useSelector(state => state.authReducer.userClaims.roles)
    const selectedCompany = useSelector(state => state.authReducer.selectedCompany)
    const [anchorEl, setAnchorEl] = useState(null);

    const {digitalContractId} = useParams()
    const dispatch = useDispatch()
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(5)
    const [areAllSelected, setAreAllSelected] = useState(false)
    const [sorting, setSorting] = useState(`${sortingCriteria[0].value},desc`)
    const [currentFilterHistory, setCurrentFilterHistory] = useState(filterInitialState)
    const [selectedSims, setSelectedSims] = useState([])

    useEffect(() => {
        if(props.isPlafondShare){
            dispatch(actions.getCurrentPlafondShare(props.selectedRow.commercialLabel, digitalContractId))
        }
        else if(props.arePianoDetails && !props.isPlafondShare) {
            dispatch(actions.fetchCurrentPlan(props.selectedRow.commercialLabel, digitalContractId))
        }
        else {
            dispatch(actions.getOpzioniPlanDetails(props.selectedRow.commercialLabel, digitalContractId, props.selectedRow.slug))
        }
        dispatch(actions.getSimsAssociatedToOptionFilterData())
        dispatch(actions.fetchSimTagsAutocomplete(''))
    }, [dispatch, props.selectedRow.commercialLabel, digitalContractId])

    useEffect(() => {
        if (!props.arePianoDetails) {
            dispatch(actions.fetchSimsAssociatedToOption(props.selectedRow.commercialLabel, page, rowsPerPage, sorting, currentFilterHistory))
        } else if(!props.isPlafondShare){
            dispatch(actions.fetchSimsAssociatedToPlan(getServiceType(props.selectedRow.familyName), props.selectedRow.commercialLabel, props.selectedRow.tipologia, page, rowsPerPage, sorting, currentFilterHistory))
        } else {
            dispatch(actions.fetchSimsAssociatedToPlafondShare(getServiceType(props.selectedRow.familyName), props.selectedRow.commercialLabel, props.selectedRow.tipologia, page, rowsPerPage, sorting, currentFilterHistory))
        }
    }, [dispatch, props.selectedRow, digitalContractId, page, rowsPerPage, sorting, currentFilterHistory, props.arePianoDetails])

    const handleAzioniClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleAggiungiSimClick = () => {
        setOpenAggiuntaSimDialog(true)
        dispatch(actions.getSimsNotAssociatedToOptionFilterData())
        dispatch(actions.fetchSimTagsAutocomplete(''))
    }

    const disableDispositiveActions = shouldDisableDispositiveActions(typeUser, roles) ||
        selectedSims.filter(sim => sim.wrenchDto.showWrench).length > 0

    const getMenuItems = [
        ...props.arePianoDetails ? [{
            text: selectedCompany.changeInSelf ? "Modifica Piano" : "Richiedi modifica piano",
            icon: null,
            disabled: disableDispositiveActions,
            handleClick: () => {
                setOpenChangePiano(true)
            },
            roles: "C"
        }] : [],
        ...!props.arePianoDetails ? [{
            text: 'Rimuovi opzione',
            icon: null,
            disabled: disableDispositiveActions,
            handleClick: () => {
                setOpenChangeOptionDialog(true)
            },
            roles: "C"
        }] : []
    ];

    const handleTablePaginationChange = (page, rowsPerPage) => {
        setPage(page);
        setRowsPerPage(rowsPerPage);
    }

    const handleSortingChange = (value) => {
        setSorting(value);
        setPage(0);
    }

    const handleFilterSearch = (name, value) => {
        setCurrentFilterHistory(currentFilterHistory => updateObject(currentFilterHistory, {
            [name]: {
                ...currentFilterHistory[name],
                value: Array.isArray(currentFilterHistory[name].value) ? [...currentFilterHistory[name].value, value] : value
            }
        }))
    }

    const handleResetFilter = () => {
        setCurrentFilterHistory(filterInitialState);
    }

    const handleFilterSelectsSearch = (value) => {
        setCurrentFilterHistory(prevFilterHistory => updateObject(prevFilterHistory, value))
    }

    const handleRemoveBadge = (key, type, index) => {
        setCurrentFilterHistory(currentFilterHistory => updateObject(currentFilterHistory, {
            [key]: {
                ...currentFilterHistory[key],
                value: type === "primitive" ? "" : [...currentFilterHistory[key].value].filter((i, idx) => idx !== index)
            }
        }))
    }

    const getAzioniText = `Azioni${selectedSims.length ? ` (${selectedSims.length})` : ''}`

    const getChangePianoDialog = () => {
        if (selectedCompany.changeInSelf)
            return <ChangePlanBySimDialog open={openChangePiano}
                                          sims={simsToIccIdAndMsisdnList(selectedSims)}
                                          handleDialogClose={() => setOpenChangePiano(false)}
                                          isFromDC={true}/>
        return <PianoDialog open={openChangePiano}
                            screenCode={E2_01_D_03_9}
                            handleDialogClose={() => setOpenChangePiano(false)}
                            handleDialogCloseButton={() => setOpenChangePiano(false)}
                            sims={selectedSims}
                            checkActiveSr={true}/>
    }

    return (
        <>
            <SimClientSideFilter handleSearchIcon={handleFilterSearch}
                                 filter={currentFilterHistory}
                                 cercaText='Cerca SIM'
                                 handleSelectSearch={handleFilterSelectsSearch}
                                 isFromContratto
                                 arePianoDetails={props.arePianoDetails}
                                 isOption={false}
                                 showFilterButton/>

            <FilterHistory filter={currentFilterHistory}
                           removeFilter={handleRemoveBadge}
                           resetFilter={handleResetFilter}/>

            <Grid container
                  className={"mb-6"}
                  justifyContent="space-between"
                  alignItems="center">
                <Grid item>
                    <SortingDropdown sortingValue={sorting}
                                     changeSortingCriteria={handleSortingChange}
                                     sortingCriteria={sortingCriteria}/>
                </Grid>
                <Grid item>
                    {!props.arePianoDetails ?
                        <Button color="primary"
                                className={'mr-8'}
                                onClick={handleAggiungiSimClick}>
                            Aggiungi sim
                        </Button>
                        : null}

                    <Button variant="contained"
                            color="primary"
                            disabled={!selectedSims.length}
                            onClick={handleAzioniClick}>
                        {getAzioniText}
                    </Button>
                </Grid>

                <ClickableDropdown anchorEl={anchorEl}
                                   setAnchorEl={setAnchorEl}
                                   menuItems={getMenuItems}/>
            </Grid>

            <SimServerSideTable
                tableData={associatedSimsToPlan.data.data}
                selected={selectedSims}
                setSelected={setSelectedSims}
                page={page}
                rowsPerPage={rowsPerPage}
                loading={associatedSimsToPlan.loading}
                order={sorting}
                count={associatedSimsToPlan.data.totalItems}
                filter={currentFilterHistory}
                handlePaginationChange={handleTablePaginationChange}
                areAllSelected={areAllSelected}
                setAreAllSelected={setAreAllSelected}
                headCells={headCells}
            />

            {openChangePiano ? getChangePianoDialog() : null}

            {openChangeOptionDialog ? <ChangeOptionDialog open={openChangeOptionDialog}
                                                          handleDialogClose={() => setOpenChangeOptionDialog(false)}
                                                          isRemove
                                                          option={props.data}
                                                          selectedSims={selectedSims}/> : null}

            {openAggiuntaSimDialog ? <AggiuntaSimOptionDialog open={openAggiuntaSimDialog}
                                                              handleDialogClose={() => setOpenAggiuntaSimDialog(false)}
                                                              option={props.data}/> : null}
        </>
    )
}

export default AssociatedSimsToPlan
